export default __webpack_public_path__ + "static/media/animals2.e1bbc97a.jpg";